export default function GuidePage() {
  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">易欧平台使用指南</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            从账户注册到完成第一笔数字资产交易，按步骤完成以下流程。
          </p>
        </div>

        <div className="space-y-8" data-unique-module="platform-guide-checklist">
          <div className="cyber-card p-8">
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center shrink-0 text-sm font-mono font-bold">01</span>
              <div>
                <h2 className="text-xl font-semibold text-cyber-text mb-3">注册账户</h2>
                <p className="text-muted leading-relaxed">访问易欧官方网站或下载移动端APP，使用手机号或邮箱完成注册。设置高强度密码并妥善保管助记词。完成基础身份认证以提升账户功能权限。</p>
              </div>
            </div>
          </div>

          <div className="cyber-card p-8">
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center shrink-0 text-sm font-mono font-bold">02</span>
              <div>
                <h2 className="text-xl font-semibold text-cyber-text mb-3">充值数字资产</h2>
                <p className="text-muted leading-relaxed">在钱包页面选择充值币种，系统生成充值地址和时间。确认链上确认次数后资产到账，到账时间因网络拥堵程度有所不同。</p>
              </div>
            </div>
          </div>

          <div className="cyber-card p-8">
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center shrink-0 text-sm font-mono font-bold">03</span>
              <div>
                <h2 className="text-xl font-semibold text-cyber-text mb-3">开始交易</h2>
                <p className="text-muted leading-relaxed">选择交易对，查看K线图表和历史价格走势。选择交易类型（限价单或市价单），输入数量和价格，确认订单详情后提交。可在当前委托中查看订单状态。</p>
              </div>
            </div>
          </div>

          <div className="cyber-card p-8">
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center shrink-0 text-sm font-mono font-bold">04</span>
              <div>
                <h2 className="text-xl font-semibold text-cyber-text mb-3">提现与安全管理</h2>
                <p className="text-muted leading-relaxed">在资产页面选择提现，填写链上地址并确认。建议设置提现地址白名单，启用双重验证安全功能。提现前核对链上地址，少量测试后再执行大额操作。</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 p-6 cyber-card">
          <p className="text-muted text-sm">本指南仅为平台操作流程说明，不构成投资建议。数字资产交易存在价格波动风险，请根据自身风险承受能力决策。</p>
        </div>
      </div>
    </div>
  )
}
